/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateClient = /* GraphQL */ `subscription OnCreateClient(
  $filter: ModelSubscriptionClientFilterInput
  $id: String
) {
  onCreateClient(filter: $filter, id: $id) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientSubscriptionVariables,
  APITypes.OnCreateClientSubscription
>;
export const onUpdateClient = /* GraphQL */ `subscription OnUpdateClient(
  $filter: ModelSubscriptionClientFilterInput
  $id: String
) {
  onUpdateClient(filter: $filter, id: $id) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientSubscriptionVariables,
  APITypes.OnUpdateClientSubscription
>;
export const onDeleteClient = /* GraphQL */ `subscription OnDeleteClient(
  $filter: ModelSubscriptionClientFilterInput
  $id: String
) {
  onDeleteClient(filter: $filter, id: $id) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientSubscriptionVariables,
  APITypes.OnDeleteClientSubscription
>;
export const onCreateClientUser = /* GraphQL */ `subscription OnCreateClientUser(
  $filter: ModelSubscriptionClientUserFilterInput
  $ownerId: String
) {
  onCreateClientUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientUserSubscriptionVariables,
  APITypes.OnCreateClientUserSubscription
>;
export const onUpdateClientUser = /* GraphQL */ `subscription OnUpdateClientUser(
  $filter: ModelSubscriptionClientUserFilterInput
  $ownerId: String
) {
  onUpdateClientUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientUserSubscriptionVariables,
  APITypes.OnUpdateClientUserSubscription
>;
export const onDeleteClientUser = /* GraphQL */ `subscription OnDeleteClientUser(
  $filter: ModelSubscriptionClientUserFilterInput
  $ownerId: String
) {
  onDeleteClientUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientUserSubscriptionVariables,
  APITypes.OnDeleteClientUserSubscription
>;
export const onCreateClientUserInvite = /* GraphQL */ `subscription OnCreateClientUserInvite(
  $filter: ModelSubscriptionClientUserInviteFilterInput
  $ownerId: String
) {
  onCreateClientUserInvite(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientUserInviteSubscriptionVariables,
  APITypes.OnCreateClientUserInviteSubscription
>;
export const onUpdateClientUserInvite = /* GraphQL */ `subscription OnUpdateClientUserInvite(
  $filter: ModelSubscriptionClientUserInviteFilterInput
  $ownerId: String
) {
  onUpdateClientUserInvite(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientUserInviteSubscriptionVariables,
  APITypes.OnUpdateClientUserInviteSubscription
>;
export const onDeleteClientUserInvite = /* GraphQL */ `subscription OnDeleteClientUserInvite(
  $filter: ModelSubscriptionClientUserInviteFilterInput
  $ownerId: String
) {
  onDeleteClientUserInvite(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientUserInviteSubscriptionVariables,
  APITypes.OnDeleteClientUserInviteSubscription
>;
export const onCreateWorkspace = /* GraphQL */ `subscription OnCreateWorkspace(
  $filter: ModelSubscriptionWorkspaceFilterInput
  $ownerId: String
) {
  onCreateWorkspace(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkspaceSubscriptionVariables,
  APITypes.OnCreateWorkspaceSubscription
>;
export const onUpdateWorkspace = /* GraphQL */ `subscription OnUpdateWorkspace(
  $filter: ModelSubscriptionWorkspaceFilterInput
  $ownerId: String
) {
  onUpdateWorkspace(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkspaceSubscriptionVariables,
  APITypes.OnUpdateWorkspaceSubscription
>;
export const onDeleteWorkspace = /* GraphQL */ `subscription OnDeleteWorkspace(
  $filter: ModelSubscriptionWorkspaceFilterInput
  $ownerId: String
) {
  onDeleteWorkspace(filter: $filter, ownerId: $ownerId) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkspaceSubscriptionVariables,
  APITypes.OnDeleteWorkspaceSubscription
>;
export const onCreateWorkspaceUser = /* GraphQL */ `subscription OnCreateWorkspaceUser(
  $filter: ModelSubscriptionWorkspaceUserFilterInput
  $ownerId: String
) {
  onCreateWorkspaceUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkspaceUserSubscriptionVariables,
  APITypes.OnCreateWorkspaceUserSubscription
>;
export const onUpdateWorkspaceUser = /* GraphQL */ `subscription OnUpdateWorkspaceUser(
  $filter: ModelSubscriptionWorkspaceUserFilterInput
  $ownerId: String
) {
  onUpdateWorkspaceUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkspaceUserSubscriptionVariables,
  APITypes.OnUpdateWorkspaceUserSubscription
>;
export const onDeleteWorkspaceUser = /* GraphQL */ `subscription OnDeleteWorkspaceUser(
  $filter: ModelSubscriptionWorkspaceUserFilterInput
  $ownerId: String
) {
  onDeleteWorkspaceUser(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkspaceUserSubscriptionVariables,
  APITypes.OnDeleteWorkspaceUserSubscription
>;
export const onCreateItem = /* GraphQL */ `subscription OnCreateItem(
  $filter: ModelSubscriptionItemFilterInput
  $ownerId: String
) {
  onCreateItem(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateItemSubscriptionVariables,
  APITypes.OnCreateItemSubscription
>;
export const onUpdateItem = /* GraphQL */ `subscription OnUpdateItem(
  $filter: ModelSubscriptionItemFilterInput
  $ownerId: String
) {
  onUpdateItem(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateItemSubscriptionVariables,
  APITypes.OnUpdateItemSubscription
>;
export const onDeleteItem = /* GraphQL */ `subscription OnDeleteItem(
  $filter: ModelSubscriptionItemFilterInput
  $ownerId: String
) {
  onDeleteItem(filter: $filter, ownerId: $ownerId) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteItemSubscriptionVariables,
  APITypes.OnDeleteItemSubscription
>;
export const onCreateEvent = /* GraphQL */ `subscription OnCreateEvent(
  $filter: ModelSubscriptionEventFilterInput
  $ownerId: String
) {
  onCreateEvent(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventSubscriptionVariables,
  APITypes.OnCreateEventSubscription
>;
export const onUpdateEvent = /* GraphQL */ `subscription OnUpdateEvent(
  $filter: ModelSubscriptionEventFilterInput
  $ownerId: String
) {
  onUpdateEvent(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventSubscriptionVariables,
  APITypes.OnUpdateEventSubscription
>;
export const onDeleteEvent = /* GraphQL */ `subscription OnDeleteEvent(
  $filter: ModelSubscriptionEventFilterInput
  $ownerId: String
) {
  onDeleteEvent(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventSubscriptionVariables,
  APITypes.OnDeleteEventSubscription
>;
export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $ownerId: String
) {
  onCreateNotification(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotificationSubscriptionVariables,
  APITypes.OnCreateNotificationSubscription
>;
export const onUpdateNotification = /* GraphQL */ `subscription OnUpdateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $ownerId: String
) {
  onUpdateNotification(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateNotificationSubscriptionVariables,
  APITypes.OnUpdateNotificationSubscription
>;
export const onDeleteNotification = /* GraphQL */ `subscription OnDeleteNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $ownerId: String
) {
  onDeleteNotification(filter: $filter, ownerId: $ownerId) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteNotificationSubscriptionVariables,
  APITypes.OnDeleteNotificationSubscription
>;
